import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/frontend/components/ui/tooltip";

/**
 * Small `(i)` beside a heading that explains the setting on hover or focus.
 * Keeps the long explanation out of the layout while leaving it one pointer
 * away, so a dense page need not choose between terse and teachable.
 *
 * Set `namesPatient` when the label mentions a patient by name, so session
 * replay masks the tooltip text.
 */
export function InfoHint({ label, namesPatient }: { label: string; namesPatient?: boolean }) {
  return (
    <Tooltip>
      <TooltipTrigger
        type="button"
        className="inline-flex items-center"
        aria-label="More information"
      >
        <Info className="size-3.5 cursor-help text-muted-foreground" />
      </TooltipTrigger>
      <TooltipContent className="max-w-64 text-caption" data-patient={namesPatient ? "" : undefined}>
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
